import { render, staticRenderFns } from "./AppBatchQualificationConfirmation.vue?vue&type=template&id=64fb5fc2&scoped=true&"
import script from "./AppBatchQualificationConfirmation.vue?vue&type=script&lang=js&"
export * from "./AppBatchQualificationConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./AppBatchQualificationConfirmation.vue?vue&type=style&index=0&id=64fb5fc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fb5fc2",
  null
  
)

export default component.exports